import { render, staticRenderFns } from "./CalendarPermissionsCard.vue?vue&type=template&id=6d5ebb85"
import script from "./CalendarPermissionsCard.vue?vue&type=script&lang=js"
export * from "./CalendarPermissionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports